module.exports = __webpack_public_path__ + "img/icon-tlg.80046917.svg";